<template>
  <div class="warenkorb flex flex-wrap -mx-2">
    <div class="w-full lg:w-2/3 pr-2">
      <activehostcomponent v-if="!isOfficeOrderClient" :host="{}" :active="active" :away="away"></activehostcomponent>
      <orderform v-if="active == 'Y' || isOfficeOrderClient || (isLoggedIn && user.id === 1)"></orderform>
    </div>
    <div class="w-full bg-white min-h-full lg:w-1/3 lg:pin-t lg:h-full lg:pin-r minibasket-container minibasket-container--orderform px-2 overflow-auto max-h-screen">
      <basketcomponent viewtype="orderform"></basketcomponent>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Basketcomponent from '../../components/Basketcomponent.vue'
import ActiveHostComponent from '../../components/ActiveHostComponent.vue'
import Orderform from '../../components/Orderform.vue'
import axios from 'axios'
import endpoints from '../../endpoints'

export default {
  name: 'Warenkorb',

  data () {
    return {
      active: '',
      away: false
    }
  },

  computed: {
    ...mapGetters([
      'isOfficeOrderClient',
      'isLoggedIn',
      'user'
    ])
  },

  created () {
    this.init()
  },

  components: {
    'basketcomponent': Basketcomponent,
    'activehostcomponent': ActiveHostComponent,
    'orderform': Orderform
  },

  methods: {
    init (callCount) {
      if (typeof callCount === 'undefined') {
        callCount = 0
      } else if (callCount > 10) {
        console.log('recall timeout reached')
        return false
      }

      if (isNaN(Number(window.hostId)) || Number(window.hostId) < 1) {
        window.setTimeout(() => { this.init(++callCount) }, 500)
      }

      axios.post(endpoints.hostactive, {
        'hostId': window.hostId
      })
        .then(response => {
          this.active = response.data.active
        })
        .catch(e => {
          this.errors.push('Wichtige Informationen zum Anbieter konnten nicht geladen werden 😭')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .minibasket-container {
    order: -1;
    max-height: none;
    margin-bottom: 25px;

    @media (min-width: 992px) {
      order: 0;
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/basket/index.vue